import {useAlert} from "@/utils/alert";
const $alert = useAlert();

/* 화면마다 다르다고 하면 option을 param으로 받도록 수정 필요*/
const certOptions = {
  // 인증서비밀번호 암호화 설정
  encryption: 'datahub', // plain, datahub, smartaib4pc
  encryptionConfig: {
    // 기웅정보통신 DataHub API 서비스
    datahub: {
      env: 'prod', // prod: 운영토큰 이용하는 경우, dev: 개발토큰 이용하는 경우
    },
    smartaib4pc: {
      // 암호화된 KEY
      ENCKEY: '/Qlf7tf7Dby5T1ZA3Q7PaTMlqjpU34fM',
      // BASE64로 인코딩 된 IV 값
      IV: 'MTIzNDU2NzgxMjM0NTY3OA==',
    },
  },
  // 인증서 UI 타이틀
  headerTitle: '세로이 공동 인증서',
  certFilter: '법인 | 개인', // 법인, 개인 인증서 모두 출력됩니다.
  // 'hide': 만료된 인증서를 보이지 않게 만듭니다.
  // 'line-through': 만료된인증서에 취소선이 생깁니다.
  // 'all' 또는 기본값(설정 안함): 만료된 인증서가 취소선 없이 출력됩니다.
  expiredCertFilter: 'line-through',
  // 비밀번호 입력창이 포커스가 되었을때 엔터를 누르면 "확인" 버튼을 클릭합니다.
  enterOnClick: true,
  // 인증서 UI의 '닫기' 버튼을 클릭했을 때 실행되는 콜백입니다.
  onClickClose: function () {
    // 인증서 UI가 닫히기 직전에 실행됩니다.
    //window.smartaib4pc.certui.close();
  },
  // SmartAIB4PC의 설치페이지를 따로 구성하지 않고, 설치 링크를 인증서 UI에 띄우는 옵션입니다.
  standAlone: true,
};

const loadScript = (scriptPath, id) => new Promise((resolve) => {
  const script = document.createElement('script');
  script.src = scriptPath;
  script.onload = () => resolve();
  script.id = id;
  document.head.appendChild(script);
});

const isLoadScript = (id) => {
  let is = false;
  const script = document.getElementById(id);
  if (script) is = true;
  return is;
}

const loadSmartaib4pcScript = async () => {
  if (!isLoadScript('smartaib4pc')) {
    await loadScript('/portal/views/smartaib4pc.browser.js', 'smartaib4pc');
  }
  if (!isLoadScript('smartaib4pc-certui')) {
    await loadScript('/portal/views/smartaib4pc.certui.js', 'smartaib4pc-certui');
  }
}

const initSmartaib4pc = (fcltySn, certResultFunc) => {
  window.smartaib4pc.setDefaultConfig({
    uid: "00000000",
    licenseKey: "KI9LXG2BZKJ8ZD21",
    licenseUrl: "https://license-smartaib4pc.scraping.co.kr/license",
    smartaib4pcUrl: "https://localhost:2251",
    smartaib4pcVersion: ">=1.8.19", // samver range
    installDetectTimeout: 3000, // 기본값: 3000ms
    installUrl: "https://static.kwic.co.kr/e2e/smartaib/smartaib4pc/releases/download/v1.8.19/smartaib4pc_1.8.19-installer.exe",
    onSuccess: () => {
      console.log("SmartAIB4PC is ready.");
    },
    onError: (errCode, errMsg) => {
      console.log('errMsg', errMsg);
      alert(errMsg);
    },
  })

  window.smartaib4pc.init({
    uid: fcltySn.toString(),
    onSuccess: () => {
      window.smartaib4pc.certui.open(certOptions, certResultFunc.suc, certResultFunc.err);
    },
    onError: async (errCode, errMsg) => {
      if (errCode === 3) {
        await $alert(`세로이 서비스 이용을 위해서는 ${errMsg}`);
        window.location.href = window.smartaib4pc.defaultOptions.installUrl;
      }
    },
  });
};

export  { initSmartaib4pc, loadSmartaib4pcScript };
